import transformPosition from '../utils/transformPosition';
import lib from '../utils/lib';
import {
  ICON_SIZE_X,
  ICON_SIZE_Y,
  LATITUDE,
  LONGITUDE,
  ID,
} from './MapPosition';
import MapPositionListener from './MapPositionListener';

class MapMarker {
  constructor(map, marker) {
    this.id = marker[ID] || Date.now();
    this.props = marker;
    this.lib = lib();
    this.map = map;
    this.initMarker(marker.position);
    if (marker.onDragEnd) {
      this.onDragEnd(marker.onDragEnd);
    }
  }

  initMarker(position) {
    const { iconUrl, iconSize, ...rest } = this.props;
    this.position = transformPosition(position);
    this.marker = new this.lib.Marker({
      onClick: true,
      animation: this.lib.Animation.DROP,
      ...rest,
      position: this.position,
      map: this.map.getInstance(),
      icon: {
        url: iconUrl,
        scaledSize: new this.lib.Size(
          iconSize[ICON_SIZE_X],
          iconSize[ICON_SIZE_Y],
        ),
      },
    });
  }

  getPosition() {
    return {
      [LATITUDE]: this.position.lat(),
      [LONGITUDE]: this.position.lng(),
    };
  }

  setPosition(position, { animate = false } = {}) {
    this.props.position = position;
    this.position = transformPosition(position);

    if (animate) {
      this.marker.setMap(null);
      this.marker.setAnimation(this.lib.Animation.DROP);
    } else {
      this.marker.setAnimation(null);
    }

    this.marker.setPosition(this.position);

    if (animate) this.marker.setMap(this.map.getInstance());
  }

  onDragEnd(cb) {
    if (this.marker.draggable) {
      this.marker.addListener(
        'dragend',
        MapPositionListener(position => {
          this.props.position = position;
          this.map.setMarkerWasDragged(true);
          cb(position);
        }),
      );
    }
  }

  unmount() {
    this.marker.setMap(null);
    delete this.marker;
    delete this.map;
  }
}

export default MapMarker;
